import forcyteService from './ForcyteService'

class PlaygroundService {
  getPlayground = async (endpoint, data) => {
    return await forcyteService.get(endpoint, data)
  }
}

const playgroundService = new PlaygroundService()
export default playgroundService
